import type { SimpleAssignation } from "../domain/SimpleAssignation";
import type { SimpleOrder } from "../domain/SimpleOrder";

export class OrderDataForOrdersPage {
    public simpleOrder: SimpleOrder;

    public simpleAssignations: Array<SimpleAssignation>;
}
